import React from 'react'
import { cn } from '@/utils/utils'

interface MobileOverlayProps {
    className?: string
}

const MobileOverlay: React.FC<MobileOverlayProps> = ({ className }) => {
    return (
        <div
            className={cn(
                'fixed inset-0 z-[9999] bg-white flex flex-col items-center justify-center p-6 text-center',
                className
            )}
        >
            {/* Logo/Icon */}
            <div className="mb-8">
                <div className="w-16 h-16 mx-auto mb-4 bg-blue-100 rounded-full flex items-center justify-center">
                    <svg
                        className="w-8 h-8 text-blue-600"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                        />
                    </svg>
                </div>
            </div>

            {/* Main Message */}
            <div className="max-w-md mx-auto">
                <h1 className="text-2xl font-bold text-gray-900 mb-4">
                    Desktop Only
                </h1>
                <p className="text-lg text-gray-600 mb-6 leading-relaxed">
                    This application is not compatible with mobile devices.
                    Please access it from a desktop or laptop computer for the
                    best experience.
                </p>

                {/* Additional Info */}
                <div className="bg-gray-50 rounded-lg p-4 mb-6">
                    <p className="text-sm text-gray-500">
                        For optimal performance and full functionality, we
                        recommend using:
                    </p>
                    <ul className="text-sm text-gray-600 mt-2 space-y-1">
                        <li>• Chrome, Firefox, Safari, or Edge</li>
                        <li>• Minimum screen width: 1024px</li>
                        <li>• Desktop or laptop computer</li>
                    </ul>
                </div>

                {/* Contact Info */}
                <p className="text-sm text-gray-500">
                    Need help? Contact our support team for assistance.
                </p>
            </div>

            {/* Decorative Elements */}
            <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-blue-500 to-purple-600"></div>
        </div>
    )
}

export default MobileOverlay
